import { z } from 'zod';

export const ProcessingTypeSchema = z.enum(['MANUAL', 'AUTOMATIC']);
export type ProcessingType = z.infer<typeof ProcessingTypeSchema>;
